import { onChainProvider } from "../types/OnChainProvider";
import { useWeb3Context } from "./useWeb3Context";

export const useAddress = () => {
    const { address }: onChainProvider = useWeb3Context();
    return { address };
};